// Module
var code = "<template role=\"div\"> <slot></slot> </template> ";
// Exports
export default code;